import { render } from "./MediaHistoryTable.vue?vue&type=template&id=bfd89836&scoped=true"
import script from "./MediaHistoryTable.vue?vue&type=script&lang=js"
export * from "./MediaHistoryTable.vue?vue&type=script&lang=js"

import "./MediaHistoryTable.vue?vue&type=style&index=0&id=bfd89836&scoped=true&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfd89836"]])

export default __exports__